var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-menu',{attrs:{"menu":_vm.items,"collapsed":_vm.options.collapsed,"showOneChild":_vm.options.showOneChild,"width":_vm.options.expandedWidth},on:{"toggle-collapse":_vm.setCollapsed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }